import { SerializeMap } from "lib/serializerUtils";

export const insuranceRatesSerializeMap: SerializeMap<InsuranceRates> = {
  insuranceType: "insurance_type",
  standardRate: "standard_rate",
  extendedRate: "extended_rate",
  providerId: "provider_id",
  providerStandardRate: "provider_standard_rate",
  providerExtendedRate: "provider_extended_rate",
  insuredDefinedByProvider: "insured_defined_by_provider",
};
